module.exports = __webpack_public_path__ + "static/media/goods12.65fa348d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/goods12.png
// module id = 218
// module chunks = 0